import React from 'react';
import QCXSnackbar from './QCXSnackbar';

export default function QCXSuccessSnackbar({ open, content, handleClose, ...restProps }) {
  return <QCXSnackbar open={open} onClose={handleClose} content={content} severity="success" {...restProps} />;
}
